// The seams an editing surface has into SmartPageRuntime's page tree:
//  - SectionChromeContext: a function that wraps each rendered section
//    (website Make changes draws its ⚙ / ↑ ↓ control, the selection ring and
//    "+ Add a section here" around it). `rendered` is null when the section
//    is not shown on the current viewport (device visibility).
//  - BlockChromeContext: a function that wraps each rendered block (the same
//    mode's per-block toolbar, click-to-select and typing on the page). It is
//    handed the block as STORED (before bindings resolve) and returns
//    `rendered` untouched for a block it does not know (a repeated copy, a
//    header / footer block).
// Absent ⇒ the runtime renders exactly as before.

import { createContext, type ReactNode } from 'react'
import type { Block, Section } from '@/pages/designers/page/types'

export type SectionChrome = (sec: Section, index: number, rendered: ReactNode) => ReactNode

export const SectionChromeContext = createContext<SectionChrome | null>(null)

export type BlockChrome = (block: Block, rendered: ReactNode) => ReactNode

export const BlockChromeContext = createContext<BlockChrome | null>(null)
